import axios from 'axios';
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions';
// import { TRANSACTION_ID } from '@config';

// create the axios client to be consumed globally.
// default no timeout in development, use browser's fallback
export default ({ cache = false, headers = {}, timeout = 0 }) => {
  return axios.create({
    timeout: __DEV__ ? 0 : timeout,
    withCredentials: true, // always send cookie to server
    // baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json',
      //'X-Transaction-ID': TRANSACTION_ID,
      ...(!cache && { 'Cache-Control': 'no-cache' }),
      ...headers,
    },
    adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter), { threshold: 20000 }),
  });
};
